export enum FormRelations {
  pages = 'pages',
  pagesFields = 'pages.fields',
  fields = 'fields',
  submissions = 'submissions',
}
